<template>
    <div class="py-4 container-fluid">
      <div class=" row">
        <div class="col-12">
            <div class="card">
                <div class="p-3 pb-0 card-header">
                  <div class="d-flex justify-content-between">
                    <h6 class="mb-2">Casos</h6>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table align-items-center">
                    <tbody>
                      <tr v-for="(sale, index) in sales" :key="index">
                        <td class="w-30">
                          <div class="px-2 py-1 d-flex align-items-center">
                            <div class="ms-4">
                              <p class="mb-0 text-xs font-weight-bold">Código:</p>
                              <h6 class="mb-0 text-sm">{{ sale.code }}</h6>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="text-center">
                            <p class="mb-0 text-xs font-weight-bold">Cliente:</p>
                            <h6 class="mb-0 text-sm">{{ sale.customer }}</h6>
                          </div>
                        </td>
                        <td>
                          <div class="text-center">
                            <p class="mb-0 text-xs font-weight-bold">Agencia:</p>
                            <h6 class="mb-0 text-sm">{{ sale.agency }}</h6>
                          </div>
                        </td>
                        <td class="text-sm align-middle">
                          <div class="text-center col">
                            <p class="mb-0 text-xs font-weight-bold">Estado:</p>
                            <h6 class="mb-0 text-sm">{{ sale.state }}</h6>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            </div>
        </div>
      </div>
      
    </div>
  </template>
  
  <script>
  export default {
    name: "tables",
    components: {
    },
    data() {
      return {
        sales: {
          0: {
            code: "C-22889",
            customer: "Coca Cola",
            agency: "MMA",
            state: "Medios en producción",
          },
          1: {
            code: "C-22888",
            customer: "Herseys",
            agency: "MMA",
            state: "Instalado",
          },
          2: {
            code: "C-22887",
            customer: "Huggies",
            agency: "MMA",
            state: "Firmada",
          },
          3: {
            code: "C-22886",
            customer: "Maggie",
            agency: "MMA",
            state: "Medios en producción",
          },
          4: {
            code: "C-22885",
            customer: "Colgate",
            agency: "MMA",
            state: "Instalaciòn de Medios Iniciada",
          },
        },
      };
    },
  };
  </script>
  